import {CatalogConfig} from '../types'

// Community catalogs — tags used to categorize Open Discussions and Mastermind Circles.
// Backed by community.CommunityTag. Read is still exposed via CommunityTagViewSet inside
// the community app; admin CRUD lives under /catalog/admin/community-tags/.

export const communityTagsConfig: CatalogConfig = {
  slug: 'community-tags',
  endpoint: '/catalog/admin/community-tags/',
  titleId: 'CATALOG.COMMUNITY_TAGS.TITLE',
  singularId: 'CATALOG.COMMUNITY_TAGS.SINGULAR',
  primaryField: 'name',
  writable: true,
  reorderable: true,
  softDelete: {field: 'isActive', activeValue: true},
  serverSide: {
    searchParam: 'search',
    orderingParam: 'ordering',
    statusParam: 'isActive',
    sortableFields: ['order', 'name'],
    defaultOrdering: 'order',
  },
  fields: [
    {name: 'order', labelId: 'CATALOG.FIELD.ORDER', type: 'text', showInTable: true},
    {
      name: 'name',
      labelId: 'CATALOG.FIELD.NAME',
      type: 'text',
      showInTable: true,
      searchable: true,
      required: true,
      maxLength: 50,
    },
  ],
}

export const communityCatalogConfigs: CatalogConfig[] = [communityTagsConfig]
